<!-- esling-disable -->
<route>
{
  "meta": {
    "requiresAuth": true
  }
}
</route>
<template>
  <div class="my-0 mx-auto text-center">
    <h1>{{ message }}</h1>
  </div>
</template>

<script>
import store from '@/store';
import UserInfo from '@/services/userInfo';
import utils from '@/services/utils';

export default {
  name: 'member-onboard',
  store,
  data() {
    return {
      topicId: '',
      message: 'Redirecting to topics...',
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  methods: {
    async onboardMember() {
      const res = await UserInfo.onboardMember(this.topicId);
      if (res.status !== 200) {
        this.message = 'Something went wrong';
        utils.setStatusMsg(this, this.message);
      } else {
        this.message = res.data.message;
        utils.setStatusMsg(this, this.message);
        this.$router.push(`/c/${res.data.topic.topicId}`);
      }
    },
  },
  async mounted() {
    this.topicId = this.$route.query.t;
    if (this.user) {
      await this.onboardMember();
    }
  },
  watch: {
    async user() {
      if (this.user) {
        await this.onboardMember();
      }
      console.log('watching', this.user);
    },
  },
};
</script>
